<template>
  <div>
    <h2 class="box__title">{{ $t('googleDriveUserFileUpload.title') }}</h2>
    <Error :error="error"></Error>
    <div v-if="!driveEnabled" class="alert alert--warning">
      {{ $t('googleDriveUserFileUpload.notConfigured') }}
    </div>
    <template v-else>
      <p class="margin-bottom-2">
        {{ $t('googleDriveUserFileUpload.description') }}
      </p>
      <div class="actions actions--right">
        <Button
          type="primary"
          size="large"
          icon="iconoir-google-drive"
          :loading="loading"
          @click="pickAndUpload()"
        >
          {{ $t('googleDriveUserFileUpload.choose') }}
        </Button>
      </div>
      <div v-if="progress" class="margin-top-2">
        {{ progress }}
      </div>
    </template>
  </div>
</template>

<script>
import error from '@baserow/modules/core/mixins/error'
import UserFileService from '@baserow/modules/core/services/userFile'

export default {
  name: 'GoogleDriveUserFileUpload',
  mixins: [error],
  emits: ['uploaded'],
  data() {
    return {
      loading: false,
      progress: '',
    }
  },
  computed: {
    driveEnabled() {
      return !!this.$googleDrive?.enabled
    },
  },
  methods: {
    async pickAndUpload() {
      this.hideError()
      this.loading = true
      try {
        const docs = await this.$googleDrive.pickFiles({ multiselect: true })
        if (docs.length === 0) {
          return
        }
        const uploaded = []
        for (const [index, doc] of docs.entries()) {
          this.progress = this.$t('googleDriveUserFileUpload.progress', {
            current: index + 1,
            total: docs.length,
            name: doc.name,
          })
          const file = await this.$googleDrive.downloadFile(doc)
          if (file === null) {
            continue
          }
          const { data } = await UserFileService(this.$client).uploadFile(file)
          uploaded.push(data)
        }
        if (uploaded.length > 0) {
          this.$emit('uploaded', uploaded)
        }
      } catch (err) {
        this.handleError(err, 'userFile')
      } finally {
        this.progress = ''
        this.loading = false
      }
    },
  },
}
</script>
